import { environment as compiledEnv } from './environment';
import { environment as prod } from './environment.prod';
import { environment as uat } from './environment.uat';
import { environment as dev } from './environment.int';
import { environment as qa } from './environment.QA';

export const mapping = {
  'localhost': compiledEnv,

  'portalpas-dev.sancristobalonline.com.ar': dev,
  'portalpas-qa.sancristobalonline.com.ar': qa,
  'productores-uat.sancristobalonline.com.ar': uat,
  'productores.sancristobal.com.ar': prod,
  'd13bec0grjjaq2.cloudfront.net': prod,

  'siniestros-dev.sancristobalonline.com.ar': dev,
  'siniestros-staging.sancristobalonline.com.ar': qa,
  'siniestros-uat.sancristobalonline.com.ar': uat,
  'siniestros.sancristobal.com.ar': prod,
  'siniestros.sancristobal.com.ar-02': prod,
};